import * as Sentry from '@sentry/browser';

export const initSentry = (dsn, release) => {
    if (!dsn || !release) {
        throw new Error('Sentry DSN or release info are missing');
    }

    Sentry.init({
        dsn,
        release
    });
};
